import React, {useState, Fragment} from 'react';
import { gtmSend } from '../../../helpers';
import {getUrlParameter} from '@tickled-media/web-components.tm-helpers';
import { Icon } from '../../Common/Icon';

const ReplySortDropdown = (props) => {

	const [showDropdown, toggleShowDropdown] = useState(false);
	const {t, replyCount, reply_sorting, changeReplySorting, selectedSort, repliesFetch, id} = props;

	const handleChangeSort = (value, label) => {
		toggleShowDropdown(!showDropdown);
		if(label !== selectedSort){
			gtmSend('dynamic', 'Reply Sort', 'change', value);
			gtmSend('cw_reply_sort', `${props.cardName}`, 'Reply Sort', 'Sort by ' + value, 0, {card_type: `${props.cardName}`, topic_name: `${props.topic.name}`, topic_id: `${props.topic.id}`, card_id: `${props.id}`});
			repliesFetch(id, (Number(getUrlParameter('page')) || 1), value, true)
	            .then(() => {
	                changeReplySorting(label);
	            });
        }
	}

	return (
		<div className={`count-sort-wrap`}>
            <div>
                {replyCount === 1 ? `1 ${t('detail_reply_count')}` : `${replyCount} ${t('detail_reply_count_plural')}`}
            </div>
            {
                reply_sorting && reply_sorting.length > 0 &&
                <Fragment>
                    <button className={`dropbtn`} onClick={() => toggleShowDropdown(!showDropdown)}>
                        {selectedSort}
                        <Icon name="dropdown-icon" className="feed-filter-arrow" />
                    </button>
                    <div className={`dropdown-content ${showDropdown ? 'show' : ''}`}>
                    	{
	                        reply_sorting.map((option) => {
	                            return (<div key={option.label} onClick={() => {handleChangeSort(option.value, option.label)}}>{option.label}</div>)
	                        })
	                    }    	
                    </div>
                    <div 
                    	className={`dropdown-content-wrapper ${showDropdown ? 'show' : ''}`} 
                    	id="dropdown-content-wrapper" 
                    	onClick={(e) => {if(e.target == document.getElementById('dropdown-content-wrapper')) toggleShowDropdown(false)}}></div>
                </Fragment>
                
            }
        </div>
	)
}

export default ReplySortDropdown;